module.exports = __webpack_public_path__ + "img/sl.abf132e3.jpg";